import { render } from "./navbar-law.vue?vue&type=template&id=9c58b5a2&scoped=true"
import script from "./navbar-law.vue?vue&type=script&lang=js"
export * from "./navbar-law.vue?vue&type=script&lang=js"

import "./navbar-law.vue?vue&type=style&index=0&id=9c58b5a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c58b5a2"]])

export default __exports__